import { AgentStoreFactory } from 'common/data/agent/store.factory';
import { configGetSettings } from 'common/helper/config/get-settings';
import { preactMarkup } from 'common/helper/preact/markup';
import { BuildingReviewAgentSwitchTemplate } from 'common/module/building-review/agent-switch/template';
import { BuildingReviewAgentSwitchViewStoreFactory } from 'common/module/building-review/agent-switch/view-store.factory';
import { MintagaReviewViewFactory } from 'common/module/building-review/mintaga-review/view.factory';
import { BuildingReviewSettingsInterface } from 'common/module/building-review/page/settings.interface';
import { BuildingReviewPageView } from 'common/module/building-review/page/view';
import { MapboxMapsViewFactory } from 'common/module/mapbox/maps/view.factory';
import { PreactView } from 'common/module/preact/view';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';
import { StatsSnowplow2ProviderService } from 'common/service/stats-snowplow2-provider/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { AgentListCommonViewStoreFactory } from 'desktop/module/agent/list-common/view-store.factory';
import { BuildingReviewAgentTemplate } from 'desktop/module/building-review/agent/template';
import { BuildingReviewButtonComponent } from 'desktop/module/building-review/button/component';

export function BuildingReviewPageViewFactory(): BuildingReviewPageView {
  return new BuildingReviewPageView(
    MapboxMapsViewFactory(),
    preactMarkup,
    {
      BuildingReviewButtonComponent,
    },
    UserAuthenticationService(),
    StatsGtmProviderService(),
    StatsSnowplow2ProviderService(),
    configGetSettings(),
    new PreactView(BuildingReviewAgentSwitchTemplate, BuildingReviewAgentSwitchViewStoreFactory()),
    AgentStoreFactory(),
    AgentStoreFactory(),
    configGetSettings<BuildingReviewSettingsInterface>(),
    new PreactView(BuildingReviewAgentTemplate, AgentListCommonViewStoreFactory()),
    new PreactView(BuildingReviewAgentTemplate, AgentListCommonViewStoreFactory()),
    MintagaReviewViewFactory()
  );
}
